import React from 'react'
import aws from "../../../images/students/aws.webp";
import fullStackDev from "../../../images/students/full-stack-dev.webp";
import softwareTesting from "../../../images/students/software-testing.webp";
import uiUx from "../../../images/students/ui-ux.webp";
import appDev from "../../../images/students/app-dev.webp";

export default function Skills() {

    const list = [
        { image: aws },
        { image: fullStackDev },
        { image: uiUx },
        { image: softwareTesting },
        { image: appDev },
    ]

  return (
     <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full overflow-hidden text-center'>
            <h3 className='text-[#101828] text-[24px] md:text-[54px] font-semibold'>Our Top 5 Tech Skill Development Training</h3>
            <div className='mt-[20px] md:mt-[48px] grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 grid gap-[15px] md:gap-[20px] md:w-11/12 mx-auto text-[#1E2939] text-[14px] md:text-[23px] font-semibold'>
                {list.map((item, index) => (
                    <div key={index} className='rounded-[8px] md:rounded-[16px] border border-[#E5E7EB] text-center'>
                        <img src={item?.image} alt='data' />
                    </div>
                ))}
            </div>
        </div>
  )
}
